jQuery(document).ready(function ($) {

    function updateHeaderScrollState() {
        $('#header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    }

    updateHeaderScrollState();

    $(window).on('load scroll resize', updateHeaderScrollState);

    function closeSitesPin() {
        const $pin = $('.site-header__sites');

        if (!$pin.hasClass('is-open')) {
            return;
        }

        $pin.removeClass('is-open');
        $pin.attr('aria-expanded', false);
        $('.site-header__bide').fadeOut(500);
    }

    function closeNavMenu() {
        const $hamburger = $('.site-header__hamburger');

        if (!$hamburger.hasClass('is-open')) {
            return;
        }

        $hamburger.removeClass('is-open');
        $hamburger.attr('aria-expanded', false);
        $('.site-header__menu').fadeOut(500);
    }

    $('.site-header__hamburger').on('click', function (event) {
        event.preventDefault();

        const $hamburger = $(this);

        closeSitesPin();

        $hamburger.toggleClass('is-open');
        $hamburger.attr('aria-expanded', $hamburger.hasClass('is-open'));
        $('#header').attr('aria-expanded', $hamburger.hasClass('is-open'));

        $('.site-header__menu').fadeToggle(500);
    });

    $('.site-header__item--toggle').on('click', function (event) {
        event.preventDefault();

        const $toggle = $(this);
        const $item = $toggle.closest('.site-header__item');

        $item.toggleClass('is-open');
        $toggle.attr('aria-expanded', $item.hasClass('is-open'));

        $item.find('.site-header__subnav').first().slideToggle(500);
    });

    $('.site-header__sites').on('click', function (event) {
        event.preventDefault();

        const $pin = $(this);

        closeNavMenu();

        $pin.toggleClass('is-open');
        $pin.attr('aria-expanded', $pin.hasClass('is-open'));
        $('#header').attr('aria-expanded', $pin.hasClass('is-open'));

        $('.site-header__bide').fadeToggle(500);
    });
});